import { Dialog } from "@blofin/blofin-ui";
import { FC, useEffect, useMemo, useState } from "react";
import { useStoreState } from "../store/useStore";
import { activeStyles, itemStyles, textStyles, titleStyles } from "./styles";
import { useTranslations } from "use-intl";
import Cookies from "js-cookie";
import useLangUpdate from "../hooks/useLangUpdate";

interface LanguageDialogProps {
  open: boolean;
  cancel: () => void;
  customChangeLang?: (lan: string) => void;
}

const Language = {
  en: "English",
  // 'zh-tw': '繁體中文',
  // 'ko-kr': '한국어',
  "uk-ua": "Україна",
  vi: "Tiếng Việt",
  ru: "Русский",
  es: "Español (Argentina)",
  // de: 'Deutsch',
  fr: "Français (Afrique)",
  tr: "Türkçe",
  pt: "Português (Brasil)"
};

type LanguageItemType = keyof typeof Language;

const LanguageContent: FC<{ customChangeLang?: (lan: string) => void }> = ({
  customChangeLang
}) => {
  const [menu, setMenu] = useState(0);

  const { isLogin, isDemoTrading, locale, theme, showTheme } = useStoreState();

  const realTheme = useMemo(() => {
    return showTheme ? theme : "light";
  }, [theme, showTheme]);

  const [locales, setLocales] = useState<string[]>([]);

  const t = useTranslations("header");

  const { LangUpdate } = useLangUpdate();

  const changeMenu = (menu: number) => {
    setMenu(menu);
  };

  const getCurrentUrl = (lang: string) => {
    const router = window.next?.router;

    if (!router) {
      return "";
    }

    const { basePath, asPath, pathname } = router;

    let path = "";
    if (lang === "en") {
      path = path !== "/" ? `${basePath}${asPath}` : `/${asPath}`;
    } else {
      path = path !== "/" ? `${basePath}/${lang}${asPath}` : `/${lang}${asPath}`;
    }

    // 主站首页
    if (basePath === "" && pathname === "/") {
      if (lang === "en") {
        path = "/";
      } else {
        path = `/${lang}`;
      }
    }

    return path;
  };

  const changeLang = (item: string) => {
    Cookies.set("lang", item || "en", { expires: 999 });

    if (customChangeLang) {
      customChangeLang(item);
      return;
    }

    setTimeout(async () => {
      try {
        if (isLogin) {
          if (!isDemoTrading) {
            await LangUpdate({
              lang: item || "en"
            });
          }
          window.location.href = getCurrentUrl(item);
        } else {
          window.location.href = getCurrentUrl(item);
        }
      } catch (error) {
        console.log(error);
      }
    }, 0);
  };

  useEffect(() => {
    const router = window.next?.router;
    if (router) {
      setLocales(router.locales);
    }
  }, []);

  return (
    <>
      <ul
        className={`flex border-b-[1px] border-solid ${textStyles({
          theme: realTheme
        })}`}
      >
        <li
          className={`mr-[24px] ${titleStyles({ active: menu === 0 ? "active" : null, theme: realTheme })}`}
          onClick={() => changeMenu(0)}
        >
          {t("language")}
        </li>
        {/* <li
          className={titleStyles({ active: menu === 1 ? 'active' : null, theme })}
          onClick={() => changeMenu(1)}>
          {t('currency')}
        </li> */}
      </ul>
      {menu === 0 && (
        <ul className="flex pt-[24px] text-[12px] flex-wrap ">
          {locales.map((item, index) => {
            return (
              <a key={index} onClick={() => changeLang(item)}>
                <li
                  className={`${itemStyles({ theme: realTheme })} ${
                    locale === item ? activeStyles({ theme: realTheme }) : ""
                  }`}
                >
                  {Language[item as LanguageItemType]}
                </li>
              </a>
            );
          })}
        </ul>
      )}
    </>
  );
};

const LanguageDialog: FC<LanguageDialogProps> = ({ open, cancel, customChangeLang }) => {
  const { theme, showTheme } = useStoreState();

  return (
    <Dialog
      className="blockfin-nav-header"
      theme={showTheme ? theme : "light"}
      title={null}
      size="medium"
      content={<LanguageContent customChangeLang={customChangeLang} />}
      open={open}
      cancel={cancel}
      footer={null}
    ></Dialog>
  );
};

export default LanguageDialog;
